import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import {
  O2OPartnerBranchAddInterface,
  O2OPartnerBranchEditInterface,
  O2OPartnerBranchListingInterface
} from "../interfaces/o2o-partner.interface";
import { CommonSelectionInterface } from "../../share/interface/common.interface";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class O2OPartnerBranchService {
  private basePath: string = `${environment.url}/api/O2OPartnerBranch`;

  constructor(private http: HttpClient) {}

  add(id: string, payload: O2OPartnerBranchAddInterface) {
    return this.http.post(`${this.basePath}/Add/${id}`, payload);
  }

  update(partnerId: string, payload: O2OPartnerBranchEditInterface) {
    return this.http.post(`${this.basePath}/Update/${partnerId}`, payload);
  }

  getListing(
    id: string,
    limit: number,
    offset: number,
    text = "",
    columnIndex = 0,
    sortDirection = "desc"
  ) {
    return this.http.post<{
      count: number;
      data: O2OPartnerBranchListingInterface[];
    }>(`${this.basePath}/GetListing/${id}`, {
      limit,
      offset,
      text,
      columnIndex,
      sortDirection
    });
  }

  getPartnerBranches(id: string): Observable<CommonSelectionInterface[]> {
    return this.http.get<CommonSelectionInterface[]>(
      `${this.basePath}/GetPartnerBranches/${id}`
    );
  }

  delete(id: string, branchId: string) {
    return this.http.post(`${this.basePath}/Delete/${id}`, JSON.stringify(branchId), {
      headers: { "Content-Type": "application/json" }
    });
  }
}
